import { render, staticRenderFns } from "./MessageListItem.vue?vue&type=template&id=7f23ca54&lang=pug&"
import script from "./MessageListItem.vue?vue&type=script&lang=js&"
export * from "./MessageListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MessageListItem.vue"
export default component.exports